import { PlusOutlined } from '@ant-design/icons'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { UploadFile } from '@eastcoal/formily/components/UploadFile'

export const pictureSchema: Record<string, SchemaItem> = {
  pictureIds: {
    type: 'array',
    'x-decorator': FormItem,
    'x-component': UploadFile,
    'x-component-props': {
      listType: 'picture-card',
      children: <PlusOutlined />
    }
  }
}
